import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import UsersManager from '@apis/users/UsersManager'
import { LOADING, SUCCEEDED, ERROR } from '@constants/fetchStatuses'

const initialState = {
  isFetching: false,
  isChanging: false,
  shellUser: {},
  roles: [],
  company: '',
  errorMessage: null,
  is_shell_company: false,
}

export const fetchShellUserByToken = createAsyncThunk(
  'shellUser/fetchShellUserByToken',
  async (token, { rejectWithValue }) => {
    try {
      return await UsersManager.getShellUserByToken({ token })
    } catch (err) {
      rejectWithValue(err.data)
    }
  },
)

const shellUserSlice = createSlice({
  name: 'shellUserV2',
  initialState,
  reducers: {
    resetShellUser: () => initialState,
  },
  extraReducers: {
    [fetchShellUserByToken.pending]: (state) => {
      state.status = LOADING
    },
    [fetchShellUserByToken.fulfilled]: (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          status: ERROR,
        }
      }
      const { shell_user: shellUser, ...data } = action.payload.data

      return {
        ...state,
        status: SUCCEEDED,
        shellUser,
        ...data,
      }
    },
    [fetchShellUserByToken.rejected]: (state, action) => {
      state.status = ERROR
      state.error = action.error.data
    },
  },
})

export default shellUserSlice.reducer
